import APICRUD from './apiCrud'
import URL from './urls'

export const formatNumber = number => {
  let regex = /(\d{0,3})(\d{0,3})(\d{0,4})/

  if (!number) {
    return ''
  }

  let x = number
    .substring(2, number.length + 2)
    .toString()
    .trim()
    .replace(/\D/g, '')
    .match(regex)
  return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
}

export const transformToISONumber = function(value) {
  return value
    ? '+1' +
        value
          .toString()
          .replace(/\D/g, '')
          .toString()
    : ''
}
export class Events extends APICRUD {
  show(id) {
    return this.http()
      .get(`${URL.EVENTS_URL}/${id}`)
      .then(response => {
        console.log(response.data.event.phone)
        return {
          ...response.data.event,
          phone: formatNumber(response.data.event.phone)
        }
      })
  }
  save(data) {
    console.log(data)
    if (data.event.google_address && data.event.google_address.photos) {
      data.event.google_address = this.formatPhotos(data.event.google_address)
    }
    return this.http().post(`${URL.EVENTS_CALENDAR_URL}`, {
      multiple: data.multiple,
      event: {
        ...data.event,
        phone: transformToISONumber(data.event.phone)
      }
    })
  }

  update(data) {
    if (data.event.google_address && data.event.google_address.photos) {
      data.event.google_address = this.formatPhotos(data.event.google_address)
    }
    return this.http().put(`${URL.EVENTS_UPDATE_URL}`, {
      multiple: data.multiple,
      event: {
        ...data.event,
        // eslint-disable-next-line no-useless-escape
        phone: transformToISONumber(data.event.phone)
      }
    })
  }

  delete(eventId) {
    return this.http().delete(`${URL.EVENTS_CALENDAR_URL}/${eventId}`)
  }

  getCustomerDetail(params) {
    return this.http().get(`${URL.EVENTS_CHECK_CUSTOMER}/${params.agent_id}`, {
      params: params
    })
  }
  formatPhotos(address) {
    address.photos = address.photos.map(photo => {
      return {
        ...photo,
        url: photo.url ? photo.url : photo.getUrl ? photo.getUrl() : null
      }
    })
    return address
  }

  index(options) {
    return this.http().get(
      `${URL.EVENTS_URL}/${options.viewtype}/${options.start}/${options.end}`,
      {
        params: options
      }
    )
  }
}
export default new Events()
